import styles from "./Rodape.module.css";

export default function Rodape() {
  return (
    <footer className={styles.rodape}>
      <p>Desenvolvido por Melksedeque</p>
    </footer>
  );
}
